module.exports = __webpack_public_path__ + "img/romanceboard-mccafe.346d1aeb.webp";